<template>
    <vue-perfect-scrollbar>
      <v-container grid-list-lg fluid class="answer-templates-container">
        <v-layout justify-center row wrap px-3>
          <v-flex md3 v-for="(channel, index) in channels" :key="`channel-filter-${index}`">
            <v-card
              v-ripple
              class="clickeable transitioned"
              height="55px"
              :class="{ 'elevation-3': true, 'k-orange-linear': filters.channel === channel.value, 'hovered': filters.channel !== channel.value }">
              <v-card-text @click="filters.channel = channel.value">
                <v-layout justify-center align-center>
                  <v-flex xs4>
                    <v-avatar
                      size="25"
                      class="transparent"
                    >
                      <v-icon
                        small
                        :class="{ 'k-orange-linear-text': filters.channel !== channel.value, 'white--text':filters.channel === channel.value }">
                        {{ channel.icon }}
                        </v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex xs8>
                    <v-layout row wrap>
                      <v-flex xs12 :class="{ 'white--text': filters.channel === channel.value }">
                        {{ channel.text }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <data-table
          class="mt-3 px-3"
          url="answer_templates"
          :search="search"
          :filters="filters"
          :elevation="false"
          :refresh="refresh"
          @items-reload="answers = $event">
          <template slot="search-bar">
            <v-layout row wrap mb-3>
              <v-flex md6>
                <v-text-field solo label="Buscar.." color="grey" append-icon="fas fa-search" v-model="filters.search"></v-text-field>
              </v-flex>
              <v-flex md3 >
                <v-select
                  v-model="filters.category"
                  :items="listCategories"
                  item-value="value"
                  item-text="text"
                  class="white--text"
                  label="Categoria..."
                  color="grey"
                  autocomplete
                  solo>
                </v-select>
              </v-flex>
              <v-flex md3>
                <v-btn class="k-orange-linear white--text ma-0" block large @click="dialog = true">Agregar respuesta</v-btn>
              </v-flex>
            </v-layout>
          </template>
          <template slot="content" slot-scope="{ items: answers }">
            <table class="w-100 table">
              <tbody>
                <answer-template-item
                  v-for="(item, index) in answers"
                  :item="item"
                  :key="`answer-item-${index}`"
                  @update="updateTable"
                  @edit="updateItem">
                </answer-template-item>
              </tbody>
            </table>
          </template>
        </data-table>
        <delete-dialog
          :text="deleteOptions.text"
          :id="deleteOptions.id"
          url="answer_templates"
          :show="deleteOptions.dialog"
          @deleted="refresh = !refresh"
          @close="closeDelete">
        </delete-dialog>
        <answer-template-modal
          :show="dialog"
          :channel="this.filters.channel"
          :answer="selectedAnswer"
          @file-deleted="deleteFile"
          @file-delete-error="unDeleteFile"
          @saved="refresh = !refresh"
          @close="closeAnswer">
        </answer-template-modal>
      </v-container>
    </vue-perfect-scrollbar>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { Validator } from 'vee-validate';
import EventBus from '@/event-bus';
import DataTable from '@/components/global/DataTable2';
import DeleteDialog from '@/components/global/DeleteDialogV2';
import permissionsMixin from '@/mixins/permissions';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';
import AnswerTemplateItem from './AnswerTemplateItem';
import AnswerTemplateModal from './AnswerTemplateModal';
import deleteDialogMixin from '@/mixins/deleteDialog';
import { mapGetters } from 'vuex';

// Vue.component('ChatCenterAnswerTemplateLists', answerTemplateLists);

export default {
  mixins: [
    permissionsMixin,
    deleteDialogMixin,
    emailEditorToolbarMixin,
  ],
  components: {
    DataTable,
    DeleteDialog,
    AnswerTemplateItem,
    AnswerTemplateModal,
    VuePerfectScrollbar,
  },
  created() {
    moment.locale('es');

    Validator.extend('less_than', {
      getMessage: () => 'La hora de inicio debe ser menor que la hora fin',
      validate: (value, [endHour]) => {
        const endHourMoment = moment(`2014-01-27 ${endHour}:00`, 'YYYY-MM-DD HH:mm:ss');
        return endHourMoment.isAfter(moment(`2014-01-27 ${value}:00`, 'YYYY-MM-DD HH:mm:ss'), 'minute');
      },
    }, {
      hasTarget: true,
    });
    Validator.extend('bigger_than', {
      getMessage: () => 'La hora fin debe ser mayor que la hora inicio',
      validate: (value, [startHour]) => {
        const startHourMoment = moment(`2014-01-27 ${startHour}:00`, 'YYYY-MM-DD HH:mm:ss');
        return moment(`2014-01-27 ${value}:00`, 'YYYY-MM-DD HH:mm:ss').isAfter(startHourMoment, 'minute');
      },
    }, {
      hasTarget: true,
    });

    this.weekDays = [{
      value: null,
      text: 'Todos',
    }].concat(moment.weekdays().map((item, i) => ({
      value: i,
      text: _.upperFirst(item),
    })));
    EventBus.$on('created', () => {
      this.$refs.answerTable.search();
      this.dialog = false;
    });
    EventBus.$on('update', () => {
      this.dialog = false;
      this.$refs.answerTable.search();
    });
    this.$store.dispatch('answerTemplates/GET_CATEGORIES', {});
  },
  destroyed() {
    EventBus.$off('created');
    EventBus.$off('update');
  },
  data() {
    return {
      resTable: 0,
      automaticReply: {
        day: '',
        startHour: '',
        endHour: '',
      },
      search: '',
      filters: {
        category: '',
        channel: 1,
      },
      deleteItem: {
        text: '',
        id: 0,
        show: false,
      },
      text: '',
      dialog: false,
      items: [],
      selectedAnswer: {},
      refresh: false,
    };
  },
  computed: {
    ...mapGetters({
      categories: 'answerTemplates/categories',
    }),
    listCategories() {
      return [
        {
          text: 'Todas',
          value: null,
        },
        ...this.categories,
      ];
    },
    showName() {
      let channel = this.filters.channel;
      switch (this.filters.channel) {
        case 1:
          channel = 'email';
          break;
        case 2:
          channel = 'sms';
          break;
        case 7:
          channel = 'whatsapp';
          break;
        default:
          break;
      }
      return `respuesta ${channel}`;
    },
    canSeeChatCenterWhatsapp() {
      return this.checkPermissions([
        'see_chat_center_whatsapp',
      ]);
    },
    channels() {
      let items = [
        {
          text: 'Email',
          value: 1,
          icon: 'fa-envelope',
        },
        {
          text: 'Sms',
          value: 2,
          icon: 'fa-comment',
        },
      ];
      if (this.canSeeChatCenterWhatsapp) {
        items.splice(1, 0, {
          text: 'Whatsapp',
          value: 7,
          icon: 'fab fa-whatsapp',
        });
      }
      return items;
    },
  },
  methods: {
    updateTable() {
      this.refresh = !this.refresh;
    },
    assignDelete({ name, id }) {
      this.deleteItem.text = name;
      this.deleteItem.id = id;
      this.deleteItem.show = true;
    },
    updateItem($event) {
      this.axios.get(`/answer_templates/${$event.id}`)
        .then(({ data }) => {
          this.selectedAnswer = data;
          this.dialog = true;
        }).catch(() => {
          // Error
        });
    },
    closeAnswer() {
      this.dialog = false;
      this.selectedAnswer = {};
    },
    deleteFile($event) {
      const idx = this.selectedAnswer.files.findIndex(item => item.id === $event.id);
      if (idx >= 0) {
        this.selectedAnswer.files.splice(idx, 1);
      }
    },
    unDeleteFile($event) {
      this.selectedAnswer.files.push({
        id: $event.id,
        original_name: $event.name,
      });
    },
    closeDelete() {
      this.deleteOptions.dialog = false;
      this.deleteOptions.text = '';
      this.deleteOptions.id = '';
    },
  },
  watch: {
    'form.text'(newVal) { // eslint-disable-line
      if (this.filters.channel === 1 && this.text !== newVal) {
        this.text = newVal;
      }
      if (!this.dialog && !newVal) {
        this.text = '';
      }
    },
    'form.channel'(newVal) { // eslint-disable-line
      if (newVal.channel !== this.filters.channel) {
        this.form.channel = this.filters.channel;
      }
    },
    form: {
      deep: true,
      handler() {
        this.$validator.reset();
      },
    },
    text(newVal) {
      this.form.text = newVal;
    },
  },
};
</script>

<style scoped>
  .answer-templates-container > .container {
    padding-top: 0;
  }
  .clickeable {
    cursor: pointer;
  }
  .transitioned {
    transition: all .25s linear;
  }
  textarea {
    position: relative !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/chat_center_v2/config/AnswerTemplates.vue